import React, {Fragment} from 'react';
import Collapsible from 'react-collapsible';
import {collapsibleSettings} from '../../helpers/Helpers';
import Toggle from "../Fields/Toggle";
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";

const ToggelField = (props) => {
    const {
        input,
        label,
        placeholder,
        disabled,
        id,
        defaultValue,
        meta: {
            touched,
            error
        },
        omitCollapsible,
        expanded,
        required,
        customClick,
    } = props;

    const content = (
        <Toggle
            id={id}
            defaultValue={defaultValue}
            disabled={disabled}
            input={input}
            label={label || null}
            error={touched && error ? error : null}
            placeholder={placeholder}
            required={required}
            type={"toggle"}
            customClick={customClick}
        />
    );

    return (
        <Fragment>
            {omitCollapsible ? (
                <div>{content}</div>
            ) : (
                <Collapsible
                    {...collapsibleSettings}
                    trigger={<label className={classNamesPrefixed({"trigger__label":true})}>{label ? label : 'Toggle field'}</label>}
                    open={expanded}
                >
                    {content}
                </Collapsible>
            )}
        </Fragment>
    );
};

export default ToggelField;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/ToggleField.js